import { Rol, Persona, Tenant, Consorcio } from '../../../../src/app/shared/model';

export class Usuario {
    constructor(
        public readonly Id: number | null,
        public PersonaId: number | null,
        public readonly Persona: Persona | null,
        public readonly Movil: string | null,
        public readonly Login: string | null,
        public readonly Clave: string | null,
        public readonly Mail: string | null,
        public readonly FotoPerfilUrl: string | null,
        public readonly FechaUltimoInicioSesion: Date | null,
        public readonly UsuarioEstadoId: number | null,
        public readonly IntentosFallidosClave: number | null,
        public readonly MotivoBloqueo: string | null,
        public readonly AceptaCondiciones: boolean | null,
        public readonly DebeCambiarClave: boolean | null,
        public Bloqueado: boolean,
        public Activo: boolean,
        public readonly Roles: Rol[],
        public readonly Tenants: Tenant[],
        public readonly Consorcios: Consorcio[],
        public readonly Comunidades: UsuarioComunidadDto[]
    ) { }

    static getNewInstance() {
        return new Usuario(null, null, null, null, null, null, null, null, null, null, null, null, false, false, false, true, [], [], [], []);
    }
}

export class RegisterUsuarioDto {
    constructor(
        public readonly Nombre: string | null,
        public readonly Apellido: string | null,
        public readonly PaisId: number,
        public readonly TipoDocumentoId: number,
        public readonly NroDocumento: string | null,
        public readonly Cuit: string | null,
        public readonly FechaNacimiento: Date,
        public readonly Mail: string | null,
        public readonly Movil: string | null,
        public readonly Login: string | null,
        public readonly Password: string | null,
        public readonly AceptaCondiciones: boolean,
        public readonly FotoDniFrenteBase64: string | null,
        public readonly FotoDniFrenteExtension: string | null,
        public readonly FotoDniDorsoBase64: string | null,
        public readonly FotoDniDorsoExtension: string | null,
        public readonly FotoSelfieBase64: string | null,
        public readonly FotoSelfieExtension: string
    ) { }
}

export class ResetPasswordDto {
    constructor(
        public readonly Login: string
    ) { }
}

export class ForgotUserDto {
    constructor(
        public readonly UserMail: string
    ) { }
}

export class SaveUsuarioDto {
    constructor(
        public readonly Id: number,
        public readonly PersonaId: number | null,
        public readonly Nombre: string | null,
        public readonly Apellido: string | null,
        public readonly NroDocumento: string | null,
        public readonly Movil: string | null,
        public readonly Login: string | null,
        public readonly Clave: string | null,
        public readonly Mail: string | null,
        public readonly CognitoPool: number | null,
        public readonly FotoPerfilBase64: string | null,
        public readonly FotoPerfilExtension: string | null,
        public UsuarioEstadoId: number | null,
        public readonly MotivoBloqueo: string | null,
        public DebeCambiarClave: boolean,
        public Bloqueado: boolean,
        public Activo: boolean,
        public Roles: number[],
        public Consorcios: number[],
        public Comunidades: UsuarioComunidadDto[]
    ) { }
}

export class UsuarioComunidadDto {
    constructor(
        public readonly Id: number,
        public readonly UsuarioId: number,
        public readonly UsuarioLogin: string | null,
        public readonly ComunidadId: number,
        public readonly Comunidad: string | null,
        public readonly PedidoComunidadRol: number,
        public readonly PedidoComunidadRolNombre: string | null,
        public readonly TenantId: number
    ) { }
}

export class SearchUsuariosRequestDto {
    constructor(
        public readonly PageSize: number | null,
        public readonly PageNumber: number | null,
        public readonly OrderAscending: boolean | null,
        public readonly OrderFieldName: string | null,
        public readonly Login: string | null,
        public readonly Nombre: string | null,
        public readonly Apellido: string | null,
        public readonly NroDocumento: string | null,
        public readonly Mail: string | null,
        public readonly Movil: string | null,
        public readonly PersonaId: number | null,
        public readonly RolId: number | null,
        public readonly EstadoId: number | null,
        public readonly VerSoloActivos: boolean | null,
        public readonly VerSoloBloqueados: boolean | null
    ) { }
}

export class SearchUsuariosResponseDto {
    constructor(
        public readonly count: number,
        public readonly result: SearchUsuariosItemDto[]
    ) { }
}

export class SearchUsuariosItemDto {
    constructor(
        public readonly Id: number,
        public readonly PersonaId: number | null,
        public readonly Login: string | null,
        public readonly Nombre: string | null,
        public readonly Apellido: string | null,
        public readonly NroDocumento: string | null,
        public readonly Movil: string | null,
        public readonly Estado: string | null,
        public readonly RolNombre: string | null,
        public readonly Activo: boolean,
        public readonly Bloqueado: boolean,
        public readonly FotoPerfilUrl: string | null,
        public readonly Mail: string | null,
        public readonly FechaUltimoInicioSesion: Date | null,
    ) { }
}

export class SearchUsuarioHistorialRequestDto {
    constructor(
        public readonly PageSize: number | null,
        public readonly PageNumber: number | null,
        public readonly OrderAscending: boolean | null,
        public readonly OrderFieldName: string | null,
        public readonly FechaDesde: Date | null,
        public readonly FechaHasta: Date | null,
        public readonly UsuarioId: number | null,
        public readonly Descripcion: string
    ) { }
}

export class SearchUsuarioHistorialResponseDto {
    constructor(
        public readonly count: number,
        public readonly result: SearchUsuarioHistorialItemDto[]
    ) { }
}

export class SearchUsuarioHistorialItemDto {
    constructor(
        public readonly Id: number,
        public readonly UsuarioId: number,
        public readonly Descripcion: string | null,
        public readonly Observaciones: string | null,
        public readonly UsuarioCreacion: string | null,
        public readonly FechaCreacion: Date
    ) { }
}

export class UsuarioRol {
    constructor(
        public readonly UsuarioId: number,
        public readonly RolId: number,
        public readonly Id: number
    ) { }
}

export class ActivateUserRequestDto {
    constructor(
        public readonly UsuarioId: number,
        public readonly Activo: boolean,
        public readonly Observaciones: string
    ) { }
}

export class BlockUserRequestDto {
    constructor(
        public readonly UsuarioId: number,
        public readonly Bloqueado: boolean,
        public readonly MotivoBloqueo: string
    ) { }
}

export class ChangeUserStateRequestDto {
    constructor(
        public readonly UsuarioId: number,
        public readonly EstadoId: number,
        public readonly Observaciones: string
    ) { }
}

export class DialogUsuarioSearchComponentRequestDto {
    constructor(
        public readonly AllowMultipleSelection: boolean,
        public readonly MaxItemSelection: number
    ) { }
}

export class DialogUsuarioSearchComponentResponseDto {
    constructor(
        public readonly Cancelled: boolean,
        public readonly Items: SearchUsuariosItemDto[]
    ) { }
}

export class ChangePasswordDto {
    constructor(
        public UsuarioId: number,
        public ClaveActual: string | null,
        public ClaveNueva: string
    ){}
}
